import Request from '@request/Request';
import Model from '@models/Tour';

export default class extends Request {
  constructor(validationObserver, data = {}) {
    data = {
      ...Model.data(),
      ...data,
    };
    super(validationObserver, data);
    this.model = new Model();
  }

  async submit() {
    this.beforeSubmit();
    let data = { ...this.data() };
    delete data.species;
    try {
      let response = await this.model.save(data);
      $showSuccess(response.message, 'tours-toast');
      return response;
    } catch (error) {
      this.handleError(error);
    } finally {
      this.afterSubmit();
    }
  }
}
